import {PanelBarItem} from "@progress/kendo-react-layout/dist/npm/panelbar/PanelBarItem";
import {PanelBar} from "@progress/kendo-react-layout/dist/npm/panelbar/PanelBar";
import classes from "src/pages/Home/components/Forms/ExemptionPropertyDamagedForm/ExemptionPropertyDamaged.module.scss";
import { useEffect, useRef, useState } from "react";
import { IFormSettingModel } from "src/interfaces/form-settings.interface";
import { DatePickerChangeEvent, CalendarChangeEvent } from "@progress/kendo-react-dateinputs";
import { DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { CheckboxChangeEvent, TextAreaChangeEvent, InputChangeEvent, RadioGroupChangeEvent, Input, Checkbox, RadioGroup } from "@progress/kendo-react-inputs";
import { FormValidation } from "../InputValidator";
import { Error, Label } from "@progress/kendo-react-labels";
import { StatesInput } from "../CustomInputs/StatesInput";
import { ZipCodeInput } from "../CustomInputs/ZipCodeInput";
import { IExemptionPropertyDamagedFormThirdSection } from "src/interfaces/forms/ExemptionPropertyDamagedByDisasterForm/exemption-property-damaged-third-section.interface";
import { EmailInput } from "../CustomInputs/EmailInputs/EmailInput";
import { PhoneNumberInput } from "../CustomInputs/PhoneNumberInputs/PhoneNumberInput";
import SectionTitle from "../Shared/SectionTitle";
import { typeOfAuthorizedRepresentativeRadioButtonData } from "../Shared/RadioButtonData";

interface GeneralFormType {
    isAdminPreview?: boolean,
    setFormDataFields: (form: IExemptionPropertyDamagedFormThirdSection) => void;
    formDataFields?:  IExemptionPropertyDamagedFormThirdSection,
    formSettings?: IFormSettingModel,
    setFormIsValid: (value: boolean) => void
}

export default function ExemptionPropertyDamagedFormSecondSection(props: GeneralFormType): JSX.Element {
    const { setFormDataFields, formDataFields, formSettings, setFormIsValid } = props;
    const [isValid, setIsValid] = useState<boolean>(false);
    const [isFormTouched, setIsFormTouched] = useState<boolean>(false);
    const formRef = useRef<HTMLFormElement>(null);
    const title = <SectionTitle isFormTouched={isFormTouched} isValid={isValid} number={2} name={"Authorized Representative Information"}/>;

    function changeValueHandler(
        event:
            | CheckboxChangeEvent
            | DatePickerChangeEvent
            | TextAreaChangeEvent
            | DropDownListChangeEvent
            | InputChangeEvent
            | RadioGroupChangeEvent
            | CalendarChangeEvent,
        field: string,
        group?: string
    )
    {
        if (group) {
            setFormDataFields({
                ...formDataFields,
                [group]: {
                    ...(formDataFields as any)?.[group],
                    [field]: event.value
                }
            });
        } else {
            setFormDataFields({
                ...formDataFields,
                [field]: event.value
            });
        }
    }
    const { validationMessage, inputValidator } = FormValidation(formRef);
    const [phoneNumberInputValid, setPhoneNumberInputValid] = useState<boolean>(false);
    const [emailInputValid, setEmailInputValid] = useState<boolean>(false);
    const [mailingAddressStateInputValid, setMailingAddressStateInputValid] = useState<boolean>(false);
    const [mailingAddressZipCodeInputValid, setMailingAddressZipCodeInputValid] = useState<boolean>(false);

    function changeValidator() {
        if (formRef.current) {
            const isValid = formRef.current.checkValidity() &&
                authorizedRepresentativeTypeValidator() &&
                phoneNumberInputValid &&
                emailInputValid &&
                mailingAddressStateInputValid &&
                mailingAddressZipCodeInputValid;
            setIsValid(isValid);
            setFormIsValid(isValid);
        }
    }

    const authorizedRepresentativeTypeValidator = () => {
        return true;
        //!!(formDataFields?.AuthorizedRepresentativeType);
    };

    function onTouch(){
        if (!isFormTouched){
            setIsFormTouched(true);
        }
    }

    useEffect(() => {
        changeValidator()
    }, [
        formDataFields,
        formRef.current,
        phoneNumberInputValid,
        emailInputValid,
        mailingAddressStateInputValid,
        mailingAddressZipCodeInputValid
    ]);

    return (
       <>
            <PanelBar keepItemsMounted={true}>
                <PanelBarItem title={title} expanded={true}>
                    <form name={"Name"} className={classes.sectionForm} ref={formRef} onFocus={onTouch}>
                        <div className="container">
                            <div className={classes.information}>
                                <p>
                                    If you are an individual property owner filing this application on your own 
                                    behalf, skip to Section 3; all other applicants are required to complete Section 2.
                                </p>
                            </div>
                            <div className={classes.item}>
                                <div className={`${classes.itemFields} ${classes.bordered}`}>
                                    <div className={classes.fieldsGroup}>
                                        <Label className={classes.Label}>
                                            Authorized Representative Information
                                             
                                        </Label>
                                        <div className={`${classes.inputsGroup} ${classes.fieldsGroupW100}`}>
                                            <RadioGroup
                                                name={"AuthorizedRepresentativeType"}
                                                layout={"vertical"}
                                                disabled={formSettings?.isReadOnly}
                                                data={typeOfAuthorizedRepresentativeRadioButtonData}
                                                onChange={e => changeValueHandler(e, "AuthorizedRepresentativeType")}
                                                value={formDataFields?.AuthorizedRepresentativeType}
                                            />                                            
                                            {formDataFields?.AuthorizedRepresentativeType === "Other" &&
                                                <div className={classes.paddingTop}>
                                                    <Label className={classes.Label}>
                                                        Explain basis
                                                        {!inputValidator("AuthorizedRepresentativeTypeOther") && (
                                                            <i className={"fa fa-asterisk text-danger"}></i>
                                                        )}
                                                    </Label>
                                                    <Input
                                                        className={classes.kTextbox}
                                                        name={"AuthorizedRepresentativeTypeOther"}
                                                        placeholder={"Explain basis"}
                                                        required={true}
                                                        disabled={formSettings?.isReadOnly}
                                                        value={formDataFields?.AuthorizedRepresentativeTypeOther}
                                                        onChange={(e)=> changeValueHandler(e, "AuthorizedRepresentativeTypeOther")}
                                                    />
                                                    {!inputValidator("AuthorizedRepresentativeTypeOther") && (
                                                        <Error >{validationMessage}</Error>
                                                    )}
                                                </div> }
                                        </div>
                                    </div>
                                </div>
                                <div className={`${classes.item} ${classes.bordered}`}>
                                    <div className={classes.itemFields}>
                                        <div className={`${classes.fieldsGroup} ${classes.fieldsGroupW50} ${classes.column}`}>
                                            <Label className={classes.Label}>
                                                Name of Authorized Representative
                                            </Label>
                                            <Input
                                                className={classes.kTextbox}
                                                name={"AuthorizedRepresentativeName"}
                                                placeholder={"Name of Authorized Representative"}
                                                required={false}
                                                disabled={formSettings?.isReadOnly}
                                                value={formDataFields?.AuthorizedRepresentativeName}
                                                onChange={(e)=> changeValueHandler(e, "AuthorizedRepresentativeName")}
                                            />
                                            <Label className={classes.Label}>
                                                Driver’s License, Personal I.D. Certificate, or Social Security Number
                                            </Label>
                                            <Input
                                                className={classes.kTextbox}
                                                name={"AuthorizedRepresentativePersonalId"}
                                                placeholder={"Driver’s License, Personal I.D. Certificate, or Social Security Number"}
                                                disabled={formSettings?.isReadOnly}
                                                value={formDataFields?.AuthorizedRepresentativePersonalId}
                                                onChange={(e)=> changeValueHandler(e, "AuthorizedRepresentativePersonalId")}
                                            />
                                            <Label className={classes.Label}>
                                                Title of Authorized Representative
                                            </Label>
                                            <Input
                                                className={classes.kTextbox}
                                                name={"AuthorizedRepresentativeTitle"}
                                                placeholder={"Title of Authorized Representative"}
                                                disabled={formSettings?.isReadOnly}
                                                value={formDataFields?.AuthorizedRepresentativeTitle}
                                                onChange={(e)=> changeValueHandler(e, "AuthorizedRepresentativeTitle")}
                                            />
                                            <Label className={classes.Label}>
                                                Phone Number (area code and number)
                                            </Label>
                                            <PhoneNumberInput
                                                required={false}
                                                setFormDataFields={setFormDataFields}
                                                fieldName={"AuthorizedRepresentativePhoneNumber"}
                                                placeholder={"Phone Number (area code and number)"}
                                                formDataFields={formDataFields}
                                                isReadOnly={formSettings?.isReadOnly}
                                                setIsValidField={setPhoneNumberInputValid}
                                                validField={phoneNumberInputValid}
                                            />
                                            <Label className={classes.Label}>
                                                Email Address
                                            </Label>
                                            <EmailInput
                                                required={false}
                                                setFormDataFields={setFormDataFields}
                                                fieldName={"AuthorizedRepresentativeEmailAddress"}
                                                placeholder={"Email Address"}
                                                formDataFields={formDataFields}
                                                isReadOnly={formSettings?.isReadOnly}
                                                setIsValidField={setEmailInputValid}
                                                validField={emailInputValid}
                                            />
                                        </div>
                                        <div className={`${classes.fieldsGroup} ${classes.fieldsGroupW50} ${classes.column}`}>
                                            <div className={`${classes.itemTitle} ${classes.addressTitle}`}>
                                                <p>Mailing Address</p>
                                            </div>
                                            <div className={classes.itemFields}>
                                                <Label className={classes.Label}>
                                                    Address Line 1
                                                </Label>
                                                <Input
                                                    className={classes.kTextbox}
                                                    name={"AuthorizedRepresentativeAddressLine1"}
                                                    placeholder={"Address Line 1"}
                                                    required={false}
                                                    disabled={formSettings?.isReadOnly}
                                                    value={formDataFields?.AuthorizedRepresentativeAddressLine1}
                                                    onChange={(e)=> changeValueHandler(e, "AuthorizedRepresentativeAddressLine1")}
                                                />
                                                <Label className={classes.Label}>
                                                    Address Line 2
                                                </Label>
                                                <Input
                                                    className={classes.kTextbox}
                                                    name={"AuthorizedRepresentativeAddressLine2"}
                                                    placeholder={"Address Line 2"}
                                                    disabled={formSettings?.isReadOnly}
                                                    value={formDataFields?.AuthorizedRepresentativeAddressLine2}
                                                    onChange={(e)=> changeValueHandler(e, "AuthorizedRepresentativeAddressLine2")}
                                                />
                                            </div>
                                            <div className={`${classes.itemFields} ${classes.fieldsGroup}`}>
                                                <div className={`${classes.fieldsGroupW30}`}>
                                                    <Label className={classes.Label}>
                                                        City
                                                    </Label>
                                                    <Input
                                                        className={classes.kTextbox}
                                                        required={false}
                                                        name={"AuthorizedRepresentativeAddressCity"}
                                                        placeholder={"City"}
                                                        disabled={formSettings?.isReadOnly}
                                                        value={formDataFields?.AuthorizedRepresentativeAddressCity}
                                                        onChange={(e)=> changeValueHandler(e, "AuthorizedRepresentativeAddressCity")}
                                                    />
                                                </div>
                                                <div className={`${classes.fieldsGroupW30}`}>
                                                    <Label className={classes.Label}>
                                                        State
                                                    </Label>
                                                    <StatesInput
                                                        setFormDataFields={setFormDataFields}
                                                        fieldName={"AuthorizedRepresentativeAddressState"}
                                                        required={false}
                                                        validField={mailingAddressStateInputValid}
                                                        setIsValidField={setMailingAddressStateInputValid}
                                                        formDataFields={formDataFields}
                                                        isReadOnly={formSettings?.isReadOnly}
                                                    />
                                                </div>
                                                <div className={`${classes.fieldsGroupW20}`}>
                                                    <Label className={classes.Label}>
                                                        Zip Code
                                                    </Label>
                                                    <ZipCodeInput
                                                        setFormDataFields={setFormDataFields}
                                                        fieldName={"AuthorizedRepresentativeAddressZip"}
                                                        placeholder={"Zip"}
                                                        required={false}
                                                        formDataFields={formDataFields}
                                                        isReadOnly={formSettings?.isReadOnly}
                                                        setIsValidField={setMailingAddressZipCodeInputValid}
                                                        validField={mailingAddressZipCodeInputValid}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                   </form>
                </PanelBarItem>
            </PanelBar>
       </>
    )
}